export const uk = {
    'compact-title': 'Итого'
};
